export const AREAS_LIST_KEY = 'AREAS_LIST';
export const AREAS_ONE_KEY = 'AREAS_ONE_KEY';
